// 不在views中的model需要手动导入
// 在views文件夹下的model自动注入
const context = require.context('../views', true, /model\.js$/);

// 获取所有的path 并自动导入arr
const arr = context.keys().map((path) => context(path).default)

// arr => hashObject
export default arr.reduce((total, item) => {
    const { name, ...other } = item
    if (name === undefined) {
        console.error('name在model中必须存在')
    }
    if (total[name]) {
        console.error(`${name}已存在，name在model中需要唯一存在`)
    } else {
        total[name] = { ...other }
    }
    return total
}, {})